// Capitular monumental + retrato recortado em primeiro plano.
// A fotografia pode ter o fundo removido no editor e continua aceitando
// enquadramento, rotação e P&B como os demais templates com imagem.
import { escapeHtml, toBrLines } from '../shared/text'
import { LOGO_BRANCO_DATA_URI } from '../shared/logo'
import { PLACEHOLDER_IMAGE_DATA_URI } from '../shared/placeholder'
import { cropToImgStyle } from '../shared/crop'
import type { RenderContext, TemplateDefinition } from '../types'

const PORTRAIT_ASPECT = 488 / 612

export const CSS = `
  .tpl-capitular-foto{
    padding:0;
    overflow:hidden;
    background:#fff;
    color:#000;
    isolation:isolate;
  }
  .tpl-capitular-foto .monogram{
    position:absolute;
    z-index:1;
    left:-160px;
    top:-52px;
    width:470px;
    height:1010px;
    overflow:visible;
    font-family:'Anton',sans-serif;
    font-size:calc(850px * var(--capital-scale, 1));
    font-weight:400;
    line-height:.94;
    letter-spacing:-.055em;
    color:#000;
    transform:scale(1.35,1.14);
    transform-origin:top left;
    user-select:none;
  }
  .tpl-capitular-foto .intro{
    position:absolute;
    z-index:4;
    top:69px;
    right:43px;
    width:221px;
    font-family:'Big Shoulders',sans-serif;
    font-size:22px;
    font-weight:100;
    line-height:1.12;
    letter-spacing:.045em;
    text-align:right;
  }
  .tpl-capitular-foto .portrait{
    position:absolute;
    z-index:3;
    left:152px;
    top:194px;
    width:488px;
    height:612px;
    overflow:hidden;
  }
  .tpl-capitular-foto .portrait img{
    display:block;
    z-index:1;
  }
  .tpl-capitular-foto .logo{
    position:absolute;
    z-index:5;
    left:49px;
    bottom:68px;
    height:24px;
  }
`

function render(content: Record<string, unknown>, ctx: RenderContext = {}): string {
  const initial = escapeHtml(String(content.initial ?? 'S').trim().charAt(0).toUpperCase() || 'S')
  const intro = toBrLines(String(content.intro ?? ''))
  const capitalScale = Number(content.capitalScale ?? 1)
  const safeCapitalScale = Number.isFinite(capitalScale) ? Math.min(1.4, Math.max(0.7, capitalScale)) : 1
  const src = ctx.imageUrl || PLACEHOLDER_IMAGE_DATA_URI
  const imgStyle = cropToImgStyle(ctx.imageCrop, PORTRAIT_ASPECT)

  return `<section class="slide tpl-capitular-foto">
    <div class="monogram reveal r1" aria-hidden="true" style="--capital-scale:${safeCapitalScale}">${initial}</div>
    <p class="intro reveal r2">${intro}</p>
    <div class="portrait reveal img-reveal r3"><img src="${src}" alt="" style="${imgStyle}"></div>
    <div class="logo reveal r4"><img src="${LOGO_BRANCO_DATA_URI}" alt="Lorena"></div>
  </section>`
}

export const capitularFotoTemplate: TemplateDefinition = {
  id: 'capitular-foto',
  label: 'Capitular + foto recortada',
  tags: ['capitular', 'foto', 'retrato', 'transparência'],
  css: CSS,
  fieldsSchema: [
    {
      key: 'initial',
      label: 'Letra capitular',
      type: 'text',
      defaultValue: 'S',
      help: 'Somente o primeiro caractere será usado.',
    },
    {
      key: 'capitalScale',
      label: 'Tamanho da capitular',
      type: 'range',
      min: 0.7,
      max: 1.4,
      step: 0.05,
      defaultValue: 1,
      help: 'Aumenta ou reduz a capitular atrás da foto.',
    },
    {
      key: 'intro',
      label: 'Texto superior',
      type: 'textarea',
      placeholder: 'Da periferia de São Paulo\nao desenvolvimento de\numa tecnologia voltada ao\nmercado financeiro,',
      help: 'Cada linha vira uma quebra manual.',
    },
    {
      key: 'image',
      label: 'Foto em primeiro plano',
      type: 'image',
      aspectRatio: PORTRAIT_ASPECT,
      help: 'Use “Deixar fundo transparente” para sobrepor a pessoa à capitular.',
    },
  ],
  render,
  previewContent: {
    initial: 'S',
    capitalScale: 1,
    intro: 'Da periferia de São Paulo\nao desenvolvimento de\numa tecnologia voltada ao\nmercado financeiro,',
  },
  previewCtx: { imageUrl: PLACEHOLDER_IMAGE_DATA_URI },
}
